import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=d80992f4&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Buy.vue"
export default component.exports